<template>
  <div class="app-header">
    <div class="header-inner">
      <div class="header-brand">
        <img src="/static/img/logo/open-house-2026.png" alt="RMUTL Open House 2026" />
        <div class="brand-copy">
          <h1>RMUTL Open House</h1>
          <span>มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา</span>
        </div>
      </div>
      <router-link
        v-if="$route.name !== 'Profile' && hasAuthToken"
        class="mobile-profile-link"
        to="/profile"
        aria-label="ไปหน้าโปรไฟล์"
        title="โปรไฟล์"
      >
        <i class="ti ti-qrcode" aria-hidden="true"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    hasAuthToken () {
      const token = localStorage.getItem('token')
      return Boolean(token && token !== 'undefined' && token !== 'null')
    }
  }
}
</script>

<style scoped>
.app-header {
  position: relative;
  width: 100%;
  min-height: 120px;
  padding: 18px 12px;
  overflow: hidden;
  color: #ffffff;
  /* background:
    radial-gradient(circle at 32% 0%, rgba(255, 224, 162, 0.22), transparent 32%),
    linear-gradient(180deg, rgba(185, 130, 46, 0.24), rgba(116, 87, 60, 0)); */
  font-family: 'Mitr', sans-serif;
}

.app-header::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
}

.header-inner {
  position: relative;
  z-index: 1;
  width: min(1180px, calc(100% - 20px));
  min-height: 84px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.mobile-profile-link {
  display: none;
}

.header-brand {
  min-width: 0;
  padding: 10px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  backdrop-filter: blur(12px);
}

.header-brand img {
  height: 58px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.18));
}

.brand-copy {
  min-width: 0;
}

.brand-copy h1 {
  margin: 0;
  color: #ffffff;
  font-size: 31px;
  line-height: 1.08;
  font-weight: 600;
}

.brand-copy span {
  display: inline-flex;
  max-width: 100%;
  margin-top: 8px;
  padding: 0;
  border: 0;
  color: rgba(255, 255, 255, 0.82);
  background: transparent;
  box-shadow: none;
  font-size: 13px;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 575px) {
  .app-header {
    min-height: 120px;
    padding: 14px 12px;
  }

  .header-inner {
    min-height: 82px;
  }

  .header-brand {
    width: 100%;
    padding-right: 50px;
    overflow: hidden;
  }

  .mobile-profile-link {
    position: absolute;
    top: 10px;
    right: -20px;
    z-index: 2;
    width: 42px;
    height: 42px;
    display: inline-grid;
    place-items: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    color: #ffffff;
    background: rgba(255, 255, 255, 0.14);
    box-shadow: 0 8px 20px rgba(38, 22, 12, 0.18);
    backdrop-filter: blur(10px);
    transition: transform 0.16s ease, background 0.16s ease;
  }

  .mobile-profile-link:hover,
  .mobile-profile-link:focus-visible {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.24);
    transform: translateY(-1px);
  }

  .mobile-profile-link i {
    font-size: 24px;
  }

  .header-brand img {
    height: 48px;
    width: auto;
  }

  .brand-copy h1 {
    font-size: 24px;
  }

  .brand-copy span {
    max-width: 100%;
    font-size: 11px;
  }
}

@media (max-width: 340px) {
  .brand-copy h1 {
    font-size: 21px;
  }

  .brand-copy span {
    max-width: 190px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/HeaderView.vue